import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Flow',
  slug: 'flow',
  category: 'Flow',
  date: '2025-05-16',
  image: '',
  excerpt: 'The Goldilocks Zone is where it\'s challenging, but not overwhelming. It\'s a good level to shoot for.',
  body: `The Goldilocks Zone is that place where effort is not too easy and not too hard. When a task is too easy, we're prone to get bored, disengage, and make mistakes. When the task is too hard, we get overwhelmed and give up.

Flow is the state when we're in that Goldilocks Zone. It's where we want to shoot for when looking for a job. Or a relationship. Or a hobby. It's always good to be in a place where we're challenged but not drowning.

If you're bored, find something more challenging.

If you're overwhelmed, ratchet your expectations down a notch and find a level where you can be productive.

Take a moment to figure out how to adjust the level of challenge in your life's situations.`,
}

export default post
